import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.jpg';

const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-950 text-slate-400 border-t border-slate-900 py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        

        {/* 4-Column Layout */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10">
          
          {/* Column 1: Brand & Philosophy */}
          <div className="space-y-6">
            <div className="bg-white p-2 rounded-lg inline-block">
              <img src={logo} alt="AlgroFlix Logo" className="h-10" />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              We Don't Just Teach HR. We Build HR Professionals. Accelerate your digital transformation and career readiness under one unified brand.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-8 h-8 rounded-full bg-slate-900 hover:bg-indigo-600 hover:text-white flex items-center justify-center transition" aria-label="Facebook">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
                </svg>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-slate-900 hover:bg-sky-500 hover:text-white flex items-center justify-center transition" aria-label="Twitter">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                </svg>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-slate-900 hover:bg-pink-600 hover:text-white flex items-center justify-center transition" aria-label="Instagram">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058z" />
                </svg>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-slate-900 hover:bg-blue-700 hover:text-white flex items-center justify-center transition" aria-label="LinkedIn">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Column 2: IT Solutions */}
          <div>
            <h4 className="text-white text-sm font-bold tracking-wider uppercase mb-4">IT Services</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/it-services" className="hover:text-white transition">IT Services & Solutions</Link></li>
              <li><Link to="/it-staff-augmentation" className="hover:text-white transition">IT Staff Augmentation</Link></li>
              <li><Link to="/engagement-models" className="hover:text-white transition">Engagement Models</Link></li>
              <li><Link to="/industries-we-serve" className="hover:text-white transition">Industries We Serve</Link></li>
              <li><Link to="/why-choose-algoflix" className="hover:text-white transition">Why Choose Us</Link></li>
              <li><Link to="/careers" className="hover:text-white transition">Careers</Link></li>
            </ul>
          </div>

          {/* Column 3: HR Academy links */}
          <div>
            <h4 className="text-white text-sm font-bold tracking-wider uppercase mb-4">HR Academy</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/hr-academy" className="hover:text-white transition">Academy Overview</Link></li>
              <li><Link to="/hr-academy#enroll-form" className="hover:text-white transition">Apply for Admissions</Link></li>
              <li><Link to="/hr-academy" className="hover:text-white transition">HR Residency Program</Link></li>
              <li><Link to="/hr-academy" className="hover:text-white transition">Career Counseling</Link></li>
              <li><Link to="/hr-academy" className="hover:text-white transition">Meet the Founder</Link></li>
              <li><Link to="/contact" className="hover:text-white transition">Contact Academy</Link></li>
            </ul>
          </div>

          {/* Column 4: Contact details */}
          <div>
            <h4 className="text-white text-sm font-bold tracking-wider uppercase mb-4">Contact info</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start">
                <span className="mr-2">📍</span>
                <span>DY-78/79, British Park, Bhojpur Road, Bhopal-462047</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">🏢</span>
                <span>#1221, BTM 4th Stage, 4th Main, 1st Block, Bangalore-560076</span>
              </li>
              <li className="flex items-center">
                <span className="mr-2">📧</span>
                <a href="mailto:support@algroflix.com" className="hover:text-white transition">support@algroflix.com</a>
              </li>
              <li className="flex items-center">
                <span className="mr-2">📞</span>
                <a href="tel:+918073389099" className="hover:text-white transition">+91-8073389099</a>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-900 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-500">
          <div className="flex flex-col md:flex-row items-center gap-2 md:gap-4">
            <p>&copy; {new Date().getFullYear()} AlgroFlix. All rights reserved.</p>
            <span className="hidden md:inline text-slate-750">|</span>
            <p>
              Technology partner: <a href="https://tattvalogic.com" target="_blank" rel="noopener noreferrer" className="text-teal-500 hover:text-teal-400 hover:underline transition font-medium">Tattvalogic</a>
            </p>
          </div>
          <div className="flex space-x-6">
            <Link to="/privacy" className="hover:text-white transition">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white transition">Terms & Conditions</Link>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;